// extracted by mini-css-extract-plugin
module.exports = {"arrows":"Arrows_arrows__2f2wa"};